
































import { defineComponent, PropType } from '@vue/composition-api';
import { PixelWebsiteTypeTooltip } from '../types';
import ALink from '@/components/common/a-link/a-link.vue';
const name = 'ttam-promotion-pixel-webpsite-type';

export default defineComponent({
  name,
  components: { ALink },
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [Number, String],
      default: '',
    },
    labelName: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Object as PropType<PixelWebsiteTypeTooltip>,
      default: () => null,
    },
  },
  setup(props, { emit }) {
    const onChange = (val: string | number) => {
      emit('input', val);
    };
    return {
      name,
      onChange,
    };
  },
});
